module.exports = __webpack_public_path__ + "076c6adde1ee78fa4520c685499e4d71.png";